/**
 * 1-based display number for a photo-captured item. Photo-first capture saves
 * items with no typed name, so they are auto-named "פריט {n}" / "Item {n}".
 * Numbers need not be unique — a collision after deletions is harmless.
 *
 * @param totalItemsBefore how many items existed when the capture session began
 * @param sessionIndex 0-based index of this capture within the session
 */
export function captureItemNumber(totalItemsBefore: number, sessionIndex: number): number {
  return totalItemsBefore + sessionIndex + 1;
}
